// OK

import apiClient from "../plugins/axios-instance";
import Properties from "../properties";

const API_URL = "https://karyawan." + Properties.DOMAIN_URL + "/api/v1";

export default class SetupDataAPIService {
  constructor() {}

  static getAll = (limit, page, category) =>
    apiClient.get(API_URL + "/setup-datas", {
      params: {
        limit: limit,
        page: page,
        ...(category ? { category: category } : {}),
      },
    });

  static getById = (id) =>
    apiClient.get(API_URL + "/setup-datas/" + id);

  static create = (body) =>
    apiClient.post(API_URL + "/setup-datas", body);

  static edit = (id, body) =>
    apiClient.put(API_URL + "/setup-datas/" + id, body);

  static delete = (id) =>
    apiClient.delete(API_URL + "/setup-datas/" + id);
}
